// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__51K8y","content":"LayoutSettings_content__1zpm-"};